module.exports = __webpack_public_path__ + "img/quadradoVerdeEscuro.38a757e2.png";